import React from 'react';

import { Logo } from '../../icons/Logo';

import './ModalHeaderComponent.scss';

export const ModalHeaderComponent = ({ urlRewritten, partner, i18n }) => {
    return (
        <section className="interstitiel-modal-header flex-container-h flex-center-alt">
            <Logo />
            {partner && urlRewritten && (
                <div className="interstitiel-redirect-message">
                    {i18n.HEADER_MSG}
                    <a href={urlRewritten} title={partner ? partner.name : ''}>
                        {i18n.CLICK_HERE}
                    </a>
                </div>
            )}
        </section>
    );
};



// WEBPACK FOOTER //
// ./src/components/pages/interstitiel/ModalHeaderComponent.js